import i18n from 'utility/Translate/I18n';

export const getDecimalNumber = (value: number, fractionDigits = 2): string => {
    return new Intl.NumberFormat(i18n.t('TRANS-locale'), {
        style: 'decimal',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(value);
};
